export const customerType = {
  Customer: "customer",
  FBO: "fbo",
  Kitchen: "kitchen",
  Admin: "admin",
  Vendor: "vendor",
  Integrator: "integrator"
};
